import {useTranslation} from 'react-i18next';
import React from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param preview: Image source for visualization (required).
 * @param : Style class for container image or default style class declared (optional).
 * @param classNameWH: Style to define the size of the image and its container (optional).
 */
const ImageCardGrid = ({ preview, className = '', classNameWH = 'w-160px-h-160px' }) => {
    const { t } = useTranslation();

    return (
        <div className={`d-flex align-items-center justify-content-center ${className}`}>
            <div className={`image-card-grid ${classNameWH}`}>
                <img className={classNameWH} src={preview} alt='add' />
            </div>
        </div>
    );
};

export default ImageCardGrid;
